// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "fcc2e3b57a144dca4bf3" + ".chunk.js";
};